import script from "./BulkAddTeamMembersDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./BulkAddTeamMembersDialog.vue?vue&type=script&setup=true&lang=js"

import "./BulkAddTeamMembersDialog.vue?vue&type=style&index=0&id=4fae9821&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4fae9821"]])

export default __exports__